import { render, staticRenderFns } from "./KmtStudio.vue?vue&type=template&id=217412d1&scoped=true"
import script from "./KmtStudio.vue?vue&type=script&lang=js"
export * from "./KmtStudio.vue?vue&type=script&lang=js"
import style0 from "./KmtStudio.vue?vue&type=style&index=0&id=217412d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217412d1",
  null
  
)

export default component.exports